import React from "react";

const Footer = () => (
    <div className="ui inverted blue vertical footer segment padded clearing basic center aligned">
        <div className="ui container">
            <div className="ui row">

                <div className="ui labeled icon center">
                    <a className="item white" href="https://github.com/WebDevelopUa/youtube" target="_blank"
                       rel="noopener noreferrer">
                        <i className="github white icon"/>
                        Source Code
                    </a>
                </div>

            </div>
        </div>
    </div>
)

export default Footer